// extracted by css-extract-rspack-plugin
export default {"root":"fAWJV","clickable":"mz7MV"};